<template>
  <v-list-item v-if="hasSocialLinks" inactive>
    <v-row class="py-2 justify-center">
      <v-col v-if="socialLinks.facebook" cols="2" class="text-center">
        <a :href="socialLinks.facebook" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <v-icon color="primary" size="20">{{ mdiFacebook }}</v-icon>
        </a>
      </v-col>
      <v-col v-if="xLink" cols="2" class="text-center">
        <a :href="xLink" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <icon-x :width="20" :height="20" :icon-color="$vuetify.theme.currentTheme.primary" />
        </a>
      </v-col>
      <v-col v-if="socialLinks.youtube" cols="2" class="text-center">
        <a :href="socialLinks.youtube" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <v-icon color="primary" size="20">{{ mdiYoutube }}</v-icon>
        </a>
      </v-col>
      <v-col v-if="socialLinks.vimeo" cols="2" class="text-center">
        <a :href="socialLinks.vimeo" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <v-icon color="primary" size="20">{{ mdiVimeo }}</v-icon>
        </a>
      </v-col>
      <v-col v-if="socialLinks.instagram" cols="2" class="text-center">
        <a :href="socialLinks.instagram" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <v-icon color="primary" size="20">{{ mdiInstagram }}</v-icon>
        </a>
      </v-col>
      <v-col v-if="socialLinks.discord" cols="2" class="text-center">
        <a :href="socialLinks.discord" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <icon-discord :width="20" :height="20" :icon-color="$vuetify.theme.currentTheme.primary" />
        </a>
      </v-col>
      <v-col v-if="socialLinks.telegram" cols="2" class="text-center">
        <a :href="socialLinks.telegram" target="_blank" rel="noopener noreferrer" class="d-inline-flex">
          <icon-telegram :width="20" :height="20" :icon-color="$vuetify.theme.currentTheme.primary" />
        </a>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
import {
  mdiFacebook,
  mdiYoutube,
  mdiVimeo,
  mdiInstagram,
} from '@mdi/js';
import { get } from '@/utils/runtime-config';
import IconDiscord from '@/components/icons/IconDiscord.vue';
import IconTelegram from '@/components/icons/IconTelegram.vue';
import IconX from '@/components/icons/IconX.vue';

export default {
  name: 'TheDrawerSocialMedial',
  components: {
    IconDiscord,
    IconTelegram,
    IconX,
  },
  data() {
    return {
      mdiFacebook,
      mdiYoutube,
      mdiVimeo,
      mdiInstagram,
    };
  },
  computed: {
    socialLinks() {
      return get('branding.social', {});
    },
    xLink() {
      // `twitter` is kept as a fallback for configs not yet migrated to `x`
      return this.socialLinks.x || this.socialLinks.twitter;
    },
    hasSocialLinks() {
      const links = this.socialLinks;
      return Object.values(links).some((link) => link && link.trim() !== '');
    },
  },
};
</script>
